// translations/ar/events.ts
export const eventsTranslations = {
    events: {
      pageTitle: "الفعاليات والإعلانات",
      pageDescription: "انضم إلى فعالياتنا القادمة، الندوات عبر الإنترنت، واللقاءات المجتمعية لتعزيز معرفتك بالاختبار والتواصل مع المحترفين الآخرين.",
      upcoming: "القادمة",
      featured: "المميزة",
      past: "الفعاليات السابقة",
      loading: "جارٍ تحميل الفعاليات...",
      noUpcoming: "لا توجد فعاليات قادمة.",
      noFeatured: "لا توجد فعاليات مميزة.",
      noPast: "لا توجد فعاليات سابقة.",
      viewDetails: "عرض التفاصيل",
      register: "التسجيل",
      registerUnavailable: "التسجيل غير متاح",
      hostEvent: "استضافة فعالية",
      viewCalendar: "عرض التقويم",
      shareTitle: "شارك معرفتك مع المجتمع",
      shareDescription: "استضف ندوة أو ورشة عمل أو لقاءً شخصيًا وساهم في نمو مجتمع Quality Nexus.",
      becomeHost: "كن منظم فعالية",
      attending: "يحضر",
      showingEvents: "عرض الفعاليات",
      noTitle: "فعالية بدون عنوان",
      noDescription: "لا يوجد وصف متاح.",
      showing: "عرض",
      of: "من",
      viewAll: "جميع الفاعليات"
    }
  };